import { gql } from '@apollo/client';
import type { BrandLeadPayload } from '@/lib/brandLeads/buildBrandLeadInput';

// Public mutation (auth: false), shared with the landing page's
// /marcas/campanha form. Types are hand-written: production introspection is
// off and the generated BrandLeadInput budget enum lags the backend.
export const CREATE_BRAND_LEAD_FROM_APP = gql`
  mutation CreateBrandLeadFromApp($data: BrandLeadInput!) {
    createBrandLead(data: $data) {
      documentId
    }
  }
`;

export interface CreateBrandLeadFromAppData {
  createBrandLead: { documentId: string } | null;
}

export interface CreateBrandLeadFromAppVars {
  data: BrandLeadPayload;
}
